import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { CreditAlert } from '../../interfaces/ICreditAlert';
import { CreditAmountPipe } from '../../pipes/credit-amount.pipe';

// Credit limit popup, shared by make offer, checkout and the offer chat (HUBX-8504)
@Component({
    selector: 'app-credit-alert',
    templateUrl: './credit-alert.component.html',
    styleUrls: ['../../confirmation-popup/confirmation-popup.component.scss', './credit-alert.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf]
})
export class CreditAlertComponent {
  @Input() set alert(alert: CreditAlert) {
    this.current = alert;
    // Each line split into text and amounts; the template shows the amounts in bold
    this.lines = alert.lines.map(line => line.split(/(\{orderAmount\}|\{availableCredit\})/).map(part => {
      if (part === '{availableCredit}') {
        return { text: new CreditAmountPipe().transform(alert.availableCredit), bold: true };
      }
      if (part === '{orderAmount}') {
        return { text: CreditAlertComponent.exactAmount(alert.orderAmount), bold: true };
      }
      return { text: part, bold: false };
    }));
  }
  @Input() isMobile = false;
  @Output() closed = new EventEmitter<void>();
  current: CreditAlert;
  lines: { text: string, bold: boolean }[][] = [];
  zoomOut = false;

  // The amount tried, with cents and not rounded: 3500.4 -> $3,500.40
  private static exactAmount(value: number): string {
    return '$' + (value ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  close(e: Event) {
    e.stopPropagation();
    this.zoomOut = true;
    setTimeout(() => this.closed.emit(), 200);
  }
}
